/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import { useHolidays } from "../../provider/HolidayProvider";
import { useSnackbar } from "notistack";
import { Dayjs } from "dayjs";
import { usePickerActionsContext } from "@mui/x-date-pickers/hooks";
import DateChangeButtons from "./DateChangeButtons";
import { Box } from "@mui/material";
import { DatePickerToolbarProps } from "@mui/x-date-pickers";

export default function HolidayAwareDateChangeButtonsToolbar(props: DatePickerToolbarProps) {
  const { holidays } = useHolidays();
  const { enqueueSnackbar } = useSnackbar();

  const isHoliday = (date: Dayjs) => {
    return holidays.includes(date.format("YYYY-MM-DD"));
  };

  const getValidDate = (date: Dayjs) => {
    let validDate = date.clone();

    while (validDate.day() === 6 || validDate.day() === 0 || isHoliday(validDate)) {
      validDate = validDate.add(1, "day");
    }

    return validDate;
  };

  const onChange = (rawDate: Dayjs) => {
    const safeDate = getValidDate(rawDate);

    if (!safeDate.isSame(rawDate, "day")) {
      enqueueSnackbar("Datum automatisch angepasst, da das ausgewählte Datum ein Feiertag ist.", {
        variant: "custom",
        isNonInteractive: true,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center",
        },
      });
    }

    return safeDate;
  };

  return (
    <Box className={props.className}>
      <DateChangeButtons onChange={onChange} />
    </Box>
  );
}
